var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerpoint = function SvgPowerpoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.639 10.237a1.501 1.501 0 0 1-.877-.876l-2.761-7.36h-17.5A1.5 1.5 0 0 0 5 3.5v37A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.502V13l-7.361-2.762Z",
    fill: "#FE6C02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fillOpacity: 0.35,
    fill: "#FE6C02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 20v1h-1v8.5c0 .827-.673 1.5-1.5 1.5h-5v2H22v1h-4v-1h1.5v-2h-5c-.827 0-1.5-.673-1.5-1.5V21h-1v-1h16Zm-2 1H14v8.5c0 .275.225.5.5.5h11c.275 0 .5-.225.5-.5V21Zm-4 3v4h-1v-4h1Zm2-1v5h-1v-5h1Zm-4 3v2h-1v-2h1Z",
    fill: "#FFF"
  }))));
};
export default SvgPowerpoint;